
import { defineComponent } from "vue";
import { CDropdown, CDropdownToggle, CDropdownMenu } from "@coreui/vue";
import {
  BIconPersonFill,
  BIconKeyFill,
  BIconLockFill,
} from "bootstrap-icons-vue";

export default defineComponent({
  name: "AppAccount",
  components: {
    BIconPersonFill,
    BIconKeyFill,
    BIconLockFill,
    CDropdown,
    CDropdownToggle,
    CDropdownMenu,
  },
  methods: {
    logout() {
      this.$store.commit("auth/logout");
      this.$store.commit("toast/add", {
        type: "success",
        message: "Pomyślnie wylogowano z Panelu Mistrzów Ceremonii Ślubnych.",
      });
      this.$router.push({ name: "Login" });
    },
  },
});
